import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, map, catchError } from "rxjs";
import { HttpServiceBase } from "../classes/HttpServiceBase";
import { HttpClient } from "@angular/common/http";


@Injectable({providedIn: 'root'})
export class UserService extends HttpServiceBase {
    protected override baseUrl: string = "/user";

    constructor(
        private http: HttpClient,
    ) {
        super();
        this.assign(this);
    }

    public sendCode(params: Object): Observable<any> {
        return this._http.post(this.baseUrl + '/login/sendCode_v3', params)
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    public verifyCode(params: Object): Observable<any> {
        return this._http.post(this.baseUrl + '/login/verify', params)
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

    // public sendSsnForValidation(ssn: string, labId: string, exams: string[]): Observable<any> {
    //     return this._http.post(this.baseUrl + '/ssn', {ssn, labId, exams})
    //         .pipe(map((response: any) => response),
    //             catchError(this.handleError.bind(this)));
    // }


    public sendMessage(message: string, screen: string, phoneNumber: string, email: string, name: string): Observable<any> {
        return this._http.post(this.baseUrl + '/login/message', {message, screen, phoneNumber, email, name})
            .pipe(map((response: any) => response),
                catchError(this.handleError.bind(this)));
    }

}
